module.exports = __webpack_public_path__ + "img/2.8.ffcf0d94.png";